import { BaseEntity, int } from "./base.model";
import { Translations } from "./language.model";

export interface Question extends BaseEntity {
  id: string;
  name: string;
  type: QuestionTypeEnum;
  content: string;
  options: QuestionOption[];
  translations: Translations;
}

export interface BaseQuestionOption {
  key: string;
  label: string;
}

export interface QuestionOption extends BaseQuestionOption {
  subOptions?: QuestionOption[];
}

export enum QuestionTypeEnum {
  "datePicker" = "datePicker",
  "dateTimePicker" = "dateTimePicker",
  "singleVerticalRadio" = "singleVerticalRadio",
  "singleHorizontalRadio" = "singleHorizontalRadio",
  "dropdown" = "dropdown",
  "multipleCheckbox" = "multipleCheckbox",
  "imageVideo" = "imageVideo",
  "textInput" = "textInput",
  "multipleDropdown" = "multipleDropdown",
  "multipleRowColumnRadio" = "multipleRowColumnRadio",
}
